import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const IconCalendar = props => {
  const $ = _c(6);
  const color = props.color || "#585858";
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Group 21</title>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== color) {
    t1 = <g fill="none" fillRule="evenodd"><path stroke={color} strokeWidth={1.5} d="M1.059 1.058v24.417h21.809V1.058z" /><path d="M7.372 13.276a1.147 1.147 0 11-2.295-.002 1.147 1.147 0 012.295.002M13.111 13.276a1.147 1.147 0 11-2.295-.002 1.147 1.147 0 012.295.002M18.85 13.276a1.147 1.147 0 11-2.294-.002 1.147 1.147 0 012.295.002M7.372 19.16a1.148 1.148 0 11-2.296 0 1.148 1.148 0 012.296 0M13.111 19.16a1.148 1.148 0 11-2.295 0 1.148 1.148 0 012.295 0M18.85 19.16a1.148 1.148 0 11-2.295 0 1.148 1.148 0 012.296 0" fill={color} /><path d="M.426 6.922h23.22M6.706 1.43v2.824M16.588 1.43v2.824" stroke={color} strokeWidth={1.5} /></g>;
    $[1] = color;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props || $[4] !== t1) {
    t2 = <svg width={24} height={27} viewBox="0 0 24 27" {...props}>{t0}{t1}</svg>;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
IconCalendar.propTypes = {
  color: PropTypes.string
};
export default IconCalendar;